jQuery.noConflict();

(function($) {
    $(document).ready(function() {
        var $ = require('jquery');
        require('fancybox')($);

        $('.forPopup').fancybox({
            'scrolling' : 'no'
        });

        /* Replace search box contents */
        var searchPhrase = 'Enter keyword(s) to search';
        $('#SearchForm_SearchForm_Search').on('focus', function(){
            $(this).addClass('active');
            if($(this).val() == searchPhrase){
                $(this).val('');
            }
        });
        $('#SearchForm_SearchForm_Search').on('blur', function(){
            if($(this).val() == ''){
                $(this).val(searchPhrase);
                $(this).removeClass('active');
            }
        });

        /* Homepage slider config */
        // $("#slider3").responsiveSlides({
        //     /*auto: true,*/
        //     pager: true,
        //     nav: true,
        //     prevText: "&nbsp;",
        //     nextText: "&nbsp;",
        //     speed: 500,
        //     timeout: 12000,
        //     /*pause: true,*/
        //     pauseControls: false,
        //     pauseButton: true,
        //     namespace: "mffHome",
        //     /* next/prev callbacks kill & reload active video - simulates stop */
        //     before: function(){
        //         var theSlide = $('.mffHome1_on').find($('.gliderVideo'));
        //         theSlide.html(theSlide.html());
        //         $('#Pause .ppButton').removeClass('playing');
        //         $('#Pause .ppButton').addClass('paused');
        //     }
        // });

        //MegaMenu click handlers
        $('#MainMenu .MainMenuOption').on('click', function(){
            if($('div.blockmenu.'+$(this).data('url')).css('display') == 'block'){
                $('div.blockmenu.'+$(this).data('url')).slideUp('fast');
            }
            else {
                $('div.blockmenu').slideUp('fast');
                $('div.blockmenu.'+$(this).data('url')).slideDown('fast');
            }
        });

        // if (!$.browser.msie || ($.browser.msie && (parseInt($.browser.version, 10) > 8))) {

            var searchBarButton = $("span.search-dropdown-icon");
            var searchBar = $('div.search-bar');
            var menuButton = $("span.nav-open-button");
            var menu = $('.header .primary ul');
            var mobile = false;
            var changed = false;

            $('body').append('<div id="media-query-trigger"></div>');

            function menuWidthCheck() {
                var header_w = $('header .inner').width();
                var elements_w = menu.width() + $('.brand').width();

                if ((header_w < elements_w) || ($(window).width() <= 768)) {
                    $('body').addClass('tablet-nav');
                }
                else {
                    $('body').removeClass('tablet-nav');
                }

                mobile_old = mobile;
                if ($('#media-query-trigger').css('visibility') == 'hidden') {
                    mobile = false;
                }
                else {
                    mobile = true;
                }

                if (mobile_old != mobile) {
                    changed = true;
                }
                else {
                    changed = false;
                }
            }

            menuWidthCheck();

            $(window).resize(function() {
                menuWidthCheck();

                if (!mobile) {
                    menu.show();
                    searchBar.show();
                }
                else {
                    if (changed) {
                        menu.hide();
                        searchBar.hide();
                    }
                }
            });

            /* toggle navigation and search in mobile view */
            searchBarButton.click(function() {
                menu.slideUp();
                searchBar.slideToggle(200);
            });

            menuButton.click(function() {
                searchBar.slideUp();
                menu.slideToggle(200);
            });
        // }

    });
}(jQuery));
